import {computed} from "mobx";
import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {ScoreboardWidgetCompetitorViewModel} from "./scoreboard-widget.competitor-view-model";
import {ScoreboardWidgetStageViewModel} from "./scoreboard-widget.stage-view-model";
import {StageDomainModel} from "../../../domain/full-game/models/stage/stage-domain-model";
import {FullGameDataSource} from "../../../domain/full-game/models/full-game-data-source";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {ScoreboardWidgetConfig} from "../scoreboard-widget.config";
import {SPORT_TYPES} from "../../../core/app/consts";
import {ScoreboardWidgetTennisCompetitorViewModel} from "./scoreboard-widget.tennis-competitor-view-model";
import {Type} from "../../../infrastructure/type";
import {ScoreboardWidgetTennisStageViewModel} from "./tennis/scoreboard-widget.tennis-stage-view-model";

export class ScoreboardWidgetState extends BaseModuleState {
  dataSource: FullGameDataSource;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, ScoreboardWidgetConfig];

  @computed get shouldRenderMatchTimeRow(): String {
    const stageWithTime = this.dataSource?.game.stages?.find((stage: StageDomainModel) => stage.time);
    const shouldRenderMatchTimeRow: Boolean = Boolean(stageWithTime);

    return shouldRenderMatchTimeRow;
  }

  @computed get homeCompetitor(): ScoreboardWidgetCompetitorViewModel {
    let homeCompetitor: ScoreboardWidgetCompetitorViewModel = null;

    if (this.dataSource?.game.homeCompetitor) {
      const homeCompetitorRow: Array<String> = this.stages?.map((stage: ScoreboardWidgetStageViewModel) => stage.homeScore);
      const competitorType: Type<ScoreboardWidgetCompetitorViewModel> = this._getCompetitorViewModelType(this.dataSource?.game.homeCompetitor.sport.id);
      homeCompetitor = new competitorType(this.dataSource?.game.homeCompetitor, homeCompetitorRow);
    }

    return homeCompetitor;
  }

  @computed get awayCompetitor(): ScoreboardWidgetCompetitorViewModel {
    let awayCompetitor: ScoreboardWidgetCompetitorViewModel = null;

    if (this.dataSource?.game.awayCompetitor) {
      const awayCompetitorRow: Array<String> = this.stages?.map((stage: ScoreboardWidgetStageViewModel) => stage.awayScore);
      const competitorType: Type<ScoreboardWidgetCompetitorViewModel> = this._getCompetitorViewModelType(this.dataSource?.game.awayCompetitor.sport.id);
      awayCompetitor = new competitorType(this.dataSource?.game.awayCompetitor, awayCompetitorRow);
    }

    return awayCompetitor;
  }

  @computed get stages(): Array<ScoreboardWidgetStageViewModel> {
    const stageType: Type<ScoreboardWidgetCompetitorViewModel> = this._getStageViewModelType(this.dataSource?.game.awayCompetitor.sport.id);

    const stages: Array<ScoreboardWidgetStageViewModel> = this.dataSource?.game.stages?.map((stage: StageDomainModel) =>
      new stageType(stage, this.dataSource?.game.homeCompetitor.isWinner, this.dataSource?.game.awayCompetitor.isWinner, this.terms)
    );

    return stages;
  }

  @computed get headers(): Array<String> {
    const headers: Array<String> = this.stages?.map((stage: ScoreboardWidgetStageViewModel) => stage.title);

    return headers;
  }

  @computed get matchTimes(): Array<String> {
    const matchTimeRow: Array<String> = this.stages?.map((stage: ScoreboardWidgetStageViewModel) => stage.time);

    return matchTimeRow;
  }

  _getCompetitorViewModelType(sportId: SPORT_TYPES): Type<ScoreboardWidgetCompetitorViewModel> {
    const types = {
      [SPORT_TYPES.tennis]: ScoreboardWidgetTennisCompetitorViewModel,
    }

    return types[sportId] || ScoreboardWidgetCompetitorViewModel;
  }

  _getStageViewModelType(sportId: SPORT_TYPES): Type<ScoreboardWidgetCompetitorViewModel> {
    const types = {
      [SPORT_TYPES.tennis]: ScoreboardWidgetTennisStageViewModel,
    }

    return types[sportId] || ScoreboardWidgetStageViewModel;
  }
}
